import "./style/Trust.css";

export default function Trust() {
  return (
    <>
      <section className="trust-section">
        <div className="trust-inner">
          <div className="trust-pills">
            {["Not a journal", "Not therapy", "Not performative"].map((p) => (
              <span key={p} className="trust-pill">
                {p}
              </span>
            ))}
          </div>
          <h2 className="trust-headline">
            Private, calm, and built for honesty
          </h2>
          <p className="trust-body">
            Your reflections stay on your device. No algorithm watches your
            mood. No feed to perform for. Just you, your answers, and a
            structured path toward understanding yourself — at whatever pace
            feels right.
          </p>
        </div>
      </section>
    </>
  );
}
